<script>
export default {
  data() {
    return {
      loading: false,
      topSrc: '',
      brandList: [
        {
          name: "璟点",
          logo: require("@/assets/img/social/jingdian_logo.png"),
          qrcode: require("@/assets/img/social/jingdian_qrcode.jpg"), // 新增二维码路径
        },
        {
          name: "PREDATOR",
          logo: require("@/assets/img/social/mzb_logo.png"),
          qrcode: require("@/assets/img/social/mzb_qrcode.jpg"),
        },
        {
          name: "universal",
          logo: require("@/assets/img/social/hq_logo.png"),
          qrcode: require("@/assets/img/social/hq_qrcode.jpg"),
        },
        {
          name: "POISON by PREDATOR",
          logo: require("@/assets/img/social/dy_logo.png"),
          qrcode: require("@/assets/img/social/mzb_qrcode.jpg"),
        },
        {
          name: "CHINA PEN",
          logo: require("@/assets/img/social/sh_logo.jpg"),
          qrcode: require("@/assets/img/social/sh_qrcode.jpg"),
        },
        {
          name: "Dufferin",
          logo: require("@/assets/img/social/dfn_logo.png"),
          qrcode: require("@/assets/img/social/dfn_qrcode.jpg"),
        },
      ],
      // 新增：移动端控制二维码显示（适配触控）
      showQrcodeIndex: -1,
    }
  },
  methods: {
    // 移动端点击卡片切换二维码显示/隐藏
    toggleQrcode(idx) {
      this.showQrcodeIndex = this.showQrcodeIndex === idx ? -1 : idx;
    }
  }
}
</script>

<template>
  <div class="container" v-loading="loading">
    <div class="inside-banner">
      <el-carousel
          class="banner-carousel"
          indicator-position="none"
          loop
          autoplay
          arrow="never"
      >
        <el-carousel-item>
          <img
              src="@/assets/img/social/chat_top.png"
              alt=""
              class="carousel-img"
          />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="social-account-layout">
      <div class="welcome-section">
        <h1 class="welcome-title">Welcome 欢迎</h1>
        <div class="welcome-desc">
          欢迎关注璟点台球集团及旗下品牌的社交平台。我们珍视与您的每一次沟通，为此特地汇总了旗下品牌的社交账号，以便您能更快捷、直接地获取信息，期待与您建立更紧密的联系。
        </div>
      </div>

      <div class="accounts-section">
        <h2 class="accounts-title">品牌主要社交账户</h2>
        <div class="accounts-grid">
          <!-- 品牌卡片 - 新增二维码容器 -->
          <div
              class="account-card"
              v-for="(item, idx) in brandList"
              :key="idx"
              @click="toggleQrcode(idx)"
          >
          <!-- logo和二维码容器 -->
          <div class="logo-qrcode-wrap">
            <img :src="item.logo" :alt="item.name" class="brand-logo" />
            <!-- 二维码 - 适配移动端：hover + 点击双触发 -->
            <img
                :src="item.qrcode"
                :alt="`${item.name}二维码`"
                class="brand-qrcode"
                :class="{ 'show-qrcode': showQrcodeIndex === idx }"
            />
          </div>
          <button class="follow-btn">扫码关注 →</button>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<style scoped lang="scss">
.container{
  position: relative;
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  padding: 0 10px; // 全局左右内边距，避免移动端内容贴边
  box-sizing: border-box;
}

.inside-banner {
  position: relative;
  margin-top: 100px;
  width: 100%;
  overflow: hidden;

  @media (max-width: 768px) {
    margin-top: 80px;
  }
  @media (max-width: 480px) {
    margin-top: 60px;
  }
}

.banner-carousel {
  width: 100%;
  height: 880px !important;

  @media (max-width: 768px) {
    height: 200px !important;
  }
  @media (max-width: 480px) {
    height: 150px !important;
    // 移动端轮播图图片适配
    .carousel-img {
      object-fit: contain;
      background: #f5f5f5;
    }
  }

  :deep(.el-carousel__container) {
    height: 100%;
  }

  :deep(.el-carousel-item) {
    height: 100%;
  }
}

.banner-link {
  display: block;
  width: 100%;
  height: 100%;
}

.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.social-account-layout {
  max-width: 1100px;
  margin: 0 auto;
  padding: 20px 0; // 移除左右padding，用全局padding替代

  // 平板适配
  @media (max-width: 768px) {
    max-width: none;
    padding: 15px 0;
  }
  // 手机适配
  @media (max-width: 480px) {
    padding: 10px 0;
  }
}

.welcome-section {
  display: flex;
  align-items: center; /* 关键：垂直居中 */
  justify-content: flex-start; /* 水平靠左，保持原有布局 */
  gap: 24px;
  height: 200px; /* 固定高度200px */
  padding: 0 0 20px 0; /* 移除上下内边距，避免高度溢出 */
  border-bottom: 1px solid #eee;
  margin-bottom: 30px;
  /* 防止内容超出容器（可选） */
  overflow: hidden;

  // 平板：改为纵向布局
  @media (max-width: 768px) {
    flex-direction: column;
    height: auto; // 移除固定高度，适配内容
    gap: 15px;
    padding: 0 0 15px 0;
    margin-bottom: 20px;
    text-align: center; // 文字居中
  }
  // 手机：进一步优化间距
  @media (max-width: 480px) {
    gap: 12px;
    padding: 0 0 12px 0;
    margin-bottom: 15px;
  }
}

.welcome-title {
  font-size: 28px;
  font-weight: 500;
  color: #333;
  margin: 0;
  /* 确保标题本身垂直居中，无额外间距 */
  line-height: 1;

  // 平板适配
  @media (max-width: 768px) {
    font-size: 22px;
  }
  // 手机适配
  @media (max-width: 480px) {
    font-size: 18px;
  }
}

.welcome-desc {
  flex: 1;
  background: #f5f5f5;
  padding: 16px;
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  /* 描述文本在自身容器内垂直居中（可选优化） */
  height: calc(100% - 32px); /* 减去上下padding，填满父容器垂直空间 */
  display: flex;
  align-items: center;

  // 平板适配
  @media (max-width: 768px) {
    height: auto; // 移除固定高度
    padding: 12px;
    font-size: 13px;
    line-height: 1.5;
  }
  // 手机适配
  @media (max-width: 480px) {
    padding: 10px;
    font-size: 12px;
    line-height: 1.4;
  }
}

.accounts-title {
  font-size: 20px;
  color: #333;
  margin-bottom: 20px;
  font-weight: 500;
  text-align: center; // 移动端标题居中更美观

  // 平板适配
  @media (max-width: 768px) {
    font-size: 18px;
    margin-bottom: 15px;
  }
  // 手机适配
  @media (max-width: 480px) {
    font-size: 16px;
    margin-bottom: 12px;
  }
}

// ========== 核心修改：移动端统一两列布局 ==========
.accounts-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;

  // 平板：2列布局
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  // 手机：2列布局（核心修改：从1列改为2列）
  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px; // 减小间距，避免手机端两列太挤
  }
}

.account-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 15px;
  text-align: center;
  cursor: pointer; /* 鼠标悬浮显示手型 */
  // 移动端卡片优化
  @media (max-width: 768px) {
    padding: 12px;
    gap: 10px;
  }
  // 手机端两列布局下的卡片优化
  @media (max-width: 480px) {
    padding: 10px 8px; // 减小内边距，适配两列布局
    gap: 8px;
  }
}

/* 新增：logo+二维码容器 - 相对定位 */
.logo-qrcode-wrap {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%; // 占满卡片宽度
}

/* 调大logo尺寸（从130px改为200px，可自行调整） */
.brand-logo {
  width: 150px;
  height: 70px;
  transition: all 0.3s ease; /* 过渡动画 */
  object-fit: contain; // 确保logo完整显示
  background: #fff; // 背景色，提升logo显示效果

  // 平板适配
  @media (max-width: 768px) {
    width: 120px;
    height: 60px;
  }
  // 手机端两列布局下的logo优化
  @media (max-width: 480px) {
    width: 100px; // 进一步减小，适配两列布局
    height: 50px;
  }
}

/* 二维码样式 - 与logo等宽，默认隐藏 */
.brand-qrcode {
  position: absolute;
  top: 100%; /* 显示在logo正下方 */
  left: 50%;
  transform: translateX(-50%); // 水平居中（更精准）
  width: 100%;      /* 核心：和logo等宽，保证尺寸匹配 */
  max-width: 200px; /* 与logo最大宽度一致 */
  height: auto;
  margin-top: 10px; /* 与logo的间距 */
  opacity: 0;       /* 默认透明隐藏 */
  visibility: hidden; /* 防止占位 */
  transition: all 0.3s ease;
  z-index: 10;      /* 防止被遮挡 */
  // 移动端二维码优化
  @media (max-width: 768px) {
    max-width: 120px;
  }
  // 手机端两列布局下的二维码优化
  @media (max-width: 480px) {
    max-width: 100px; // 与手机端logo匹配
    margin-top: 8px; // 减小间距
  }
}

/* 鼠标悬浮卡片时，显示二维码+logo轻微放大 */
.account-card:hover .brand-qrcode {
  opacity: 1;
  visibility: visible;
}
.account-card:hover .brand-logo {
  transform: scale(1.02); /* 轻微放大，提升交互感 */
}

/* 移动端点击显示二维码的样式 */
.brand-qrcode.show-qrcode {
  opacity: 1;
  visibility: visible;
}

.follow-btn {
  background: #333;
  color: #fff;
  border: none;
  padding: 8px 18px;
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  border-radius: 20px;
  transition: background 0.3s ease;

  // 平板适配
  @media (max-width: 768px) {
    padding: 7px 15px;
    font-size: 11px;
  }
  // 手机端两列布局下的按钮优化
  @media (max-width: 480px) {
    padding: 6px 12px; // 减小按钮尺寸，适配两列布局
    font-size: 11px;
    border-radius: 15px; // 减小圆角，更紧凑
  }
}

/* 按钮hover效果（可选） */
.follow-btn:hover {
  background: #555;
}
</style>